<div class="myModal">

  <!--HEADER-->
  <div class="modal-header">
    <h3 id="label1">{{label1 | translate}}</h3>
    <button (click)="exitModal()" class="close" id="close"  aria-label="close">
      <h6 id="close_text">{{labelClose | translate}}</h6>
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <!--BODY-->
  <div class="modal-body">
    <div class="search mb-2" role="search">
      <input id="input-search" type="search" [placeholder]="label2 | translate" (keyup.enter)="search(searchValue)"
        [(ngModel)]="searchValue">
      <button id="button-search" (click)="search(searchValue)">
        <mat-icon>search</mat-icon>
      </button>
    </div>

    <div>
      <label>{{optionsFiltered?.length}} résultats</label>
    </div>


    <div class="list scroller">
      <div *ngFor="let item of optionsFiltered; let i = index;">
        <div class="rowList">
          <input class="mr-1 list_input" type="radio" [id]="'radio-'+i" name="radio" (change)="changeRadio(item);">
          <label>{{item.libelle | translate }} ({{item.code}})</label>
        </div>
      </div>
    </div>

    <div id="selectedElement">
      <label>{{label3 | translate }} : <label id="valueSelectedLabel" *ngIf="valueSelected">{{valueSelected?.libelle | translate }} ({{valueSelected?.code}})</label></label>
    </div>

  </div>

  <!--FOOTER-->
  <div class="modal-footer">
    <button aria-label="retour" (click)="exitModal()" class="btn btn-outline-primary" 
      aria-label="close">{{labelAnnuler | translate}}</button>
    <button aria-label="confirmer" (click)="valider()" class="btn btn-primary" 
      aria-label="close">{{labelValider | translate}}</button>
  </div>
</div>
